import {HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Observable, from, throwError, Subject, of} from 'rxjs';
import {Injectable} from '@angular/core';
import {environment} from '../../../environments/environment';
import { catchError, takeUntil } from 'rxjs/operators';
import {OktaAuth} from '@okta/okta-auth-js';

@Injectable()
export class AuthOktaInterceptor implements HttpInterceptor {
  private isAuthorized$: Subject<void> = new Subject();

  constructor(private oktaAuth: OktaAuth) {
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return from(this.handleAccess(request, next));
  }

  private async handleAccess(request: HttpRequest<any>, next: HttpHandler): Promise<HttpEvent<any>> {
    // Only add an access token to whitelisted origins
    const allowedOrigins = [environment.origin];
    if (allowedOrigins.some(url => request.urlWithParams.includes(url))) {
      const accessToken = await this.oktaAuth.getAccessToken();
      request = request.clone({
        setHeaders: {
          Authorization: 'Bearer ' + accessToken
        }
      });
    }

    return next.handle(request).pipe(
      catchError((error: Error): Observable<HttpEvent<any>> => {
        if (error instanceof HttpErrorResponse && error.status === 401) {
          this.oktaAuth.signOut().then(() => {
            this.oktaAuth.handleLoginRedirect();
          });
          this.isAuthorized$.next();
          this.isAuthorized$.complete();
          return of(null);
        }
        return throwError(error);
      }),
      takeUntil(this.isAuthorized$),
    ).toPromise();
  }
}
